/*
    Page Showing verification error and resend link
 */

import React, {Component} from 'react';
import {backendDomain} from "../modules/configs";
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import auth from '../modules/Auth0_setup';
import '../css/email-verification.css';

export default class VerificationErrorPage extends Component {
  constructor() {
    super();
    this.state = {
      sent: false,
      backToLogin: false
    };
    this.resendVerificationEmail = this.resendVerificationEmail.bind(this);
    this.goBackToLogin = this.goBackToLogin.bind(this);
  }

  resendVerificationEmail() {
    let userId = this.props.location.state.userId;
    axios.get(backendDomain + '/signup/resend?userId=' + userId)
      .then((response) => {
        this.setState({ sent: true });
      });
  }

  goBackToLogin() {
    auth.logout();
    this.setState({ backToLogin: true });
  }

  render() {
    if (this.state.sent) {
      return (
        <div>
          <h1>
            Email sent. Please check your inbox.
          </h1>
          <button onClick={() => { auth.logout(); window.location.href = '/login' }} className="email_verification_btn">Back to login</button>
        </div>
      );
    }
    if (this.state.backToLogin) {
      return <Redirect to='/login'/>
    }
    return (
      <div className="email_verification_container">
        <img src="/images/SprintRayLogo-color.png"  height="auto" width="250px" className="sprintray-color"/>
        <h2>Please verify your email before logging in</h2>
        <br/>
        <button className="email_verification_btn" onClick={this.resendVerificationEmail}>Resend Verification Email</button>
        <button className="email_verification_btn" onClick={this.goBackToLogin}>Go Back to Login Page</button>
      </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/verification_error.js